import {
  getImMissingInkUrl,
  getMyBillWasNotWhatIExpected
} from 'src/utils/urls';
import {
  MissingInkButtonClicked,
  MyBillWasNotWhatIExpectedButtonClicked
} from '../analytics';
import { CardRowProps } from '@uma/react-commons/dist/components/Card/CardWrapper/CardRow';
import { ROW_TYPE, SubscriptionType } from '@uma/react-commons/dist/index';
import { getResourceId } from 'src/utils/utils';
import { SubscriptionsProps } from '../../SubscriptionsCard/types';
import React from 'react';
import { IconInkShipmentMissing, IconReportAlert } from '@veneer/core';
import { TranslateType } from 'src/contexts/dependencyManager/types';

export async function getInstantInkAsyncRows({
  subscription,
  translate,
  language,
  country
}: {
  subscription: SubscriptionsProps;
  translate: TranslateType;
  language: string;
  country: string;
}): Promise<CardRowProps[]> {
  const resourceId = getResourceId(subscription);

  const [missingInkUrl, myBillUrl] = await Promise.all([
    getImMissingInkUrl(language, country),
    getMyBillWasNotWhatIExpected(language, country)
  ]);

  return [
    {
      index: 0,
      icon: <IconInkShipmentMissing />,
      type: ROW_TYPE.EXTERNAL,
      content: translate(
        'subscriptions.imMissingInk',
        'I’m missing ink'
      ) as string,
      link: {
        url: missingInkUrl,
        dataTestId: 'MissingInkLink'
      },
      analyticsEvent: MissingInkButtonClicked(
        resourceId,
        subscription.startDate,
        missingInkUrl
      ),
      internalKey: 'card-row-0'
    },
    {
      index: 1,
      icon: <IconReportAlert />,
      type: ROW_TYPE.EXTERNAL,
      content: translate(
        'subscriptions.myBillWasNotWhatIExpected',
        `My bill wasn't what I expected`
      ) as string,
      link: {
        url: myBillUrl,
        dataTestId: 'InstantInkMyBillWasNotWhatIExpectedLink'
      },
      analyticsEvent: MyBillWasNotWhatIExpectedButtonClicked(
        resourceId,
        subscription.startDate,
        SubscriptionType.INSTANT_INK,
        myBillUrl
      ),
      internalKey: 'card-row-1'
    }
  ];
}
